import React from 'react';
import PropTypes from 'prop-types';
import {navigate} from 'gatsby';
import UtilityButton from '@nib/utility-button';
import {Box, Columns, Column} from '@nib/layout';

const UtilityButtons = ({buttons}) => {
  return (
    <Box>
      <Columns space={6} collapseBelow="lg">
        {buttons &&
          buttons.map((b, index) => (
            <Column key={index}>
              {b.isGatsbyLink ? <UtilityButton subtitle={b.subtitle} title={b.title} onClick={() => navigate(b.url)} /> : <UtilityButton subtitle={b.subtitle} title={b.title} href={b.url} />}
            </Column>
          ))}
      </Columns>
    </Box>
  );
};

UtilityButtons.propTypes = {
  buttons: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      subtitle: PropTypes.string,
      url: PropTypes.string
    })
  ).isRequired
};

UtilityButtons.displayName = 'UtilityButtons';

export default UtilityButtons;
